import { useEffect, useState } from 'react';
/**
 * Returns the input value after `delayMs` of stability — i.e. the value only updates
 * once the caller has stopped changing it for at least `delayMs`. Useful for spacing
 * out network calls driven by typed input.
 */
export function useDebouncedValue(value, delayMs) {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const handle = setTimeout(() => setDebounced(value), delayMs);
        return () => clearTimeout(handle);
    }, [value, delayMs]);
    return debounced;
}
